import { Stack } from '@mui/material';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

import GetEncounterMode = api.Encounter.GetEncounterMode;

export function EncounterFormFields() {
  const { value: mode = GetEncounterMode.FindAll } =
    useSelectedNodeField<api.Encounter.GetEncounterMode>('config.mode');

  return (
    <Stack gap={2}>
      <BlockRadioGroupField
        fieldName="config.mode"
        label="Mode"
        row
        defaultValue={GetEncounterMode.FindAll}
        options={[
          {
            label: 'Find all for patient',
            value: GetEncounterMode.FindAll,
          },
          {
            label: 'Get one by encounter ID',
            value: GetEncounterMode.GetOneById,
          },
        ]}
      />

      {mode === GetEncounterMode.GetOneById && (
        <BlockValueTemplateField
          fieldName="config.encounterId"
          label="Encounter ID"
          helperText="Enter the reference to the Encounter ID. e.g. `{{start.data.encounterId}}`"
          placeholder="e.g. {{start.data.encounterId}}"
        />
      )}

      {mode === GetEncounterMode.FindAll && (
        <>
          <ParentBlockSelectField
            fieldName="config.patient.sourceBlockName"
            label="Patient Source"
            required
            helperText={getSourceBlockNameHelperText('patient')}
          />
          <BlockValueTemplateField fieldName="config.startDate" label="Start Date" />
          <BlockValueTemplateField fieldName="config.endDate" label="End Date" />
        </>
      )}
    </Stack>
  );
}
